import { ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';

import { BDCPFolder } from '../../../../models/folder.model';
import { BDModalComponent } from '@brother-apps/brother-dealerapp-shared-lib';
import { IBDCPFolderService } from '../../../shared/services/folder-service/folder.interface';
import { Location } from '@angular/common';

@Component({
    selector: 'bdcp-bookmarks-details',
    templateUrl: './details.page.html',
    styleUrls: ['./details.page.scss']
})
export class BDCPBookmarksDetailsComponent implements OnInit {

    @ViewChild('bookmarksModal', {static: true} ) public bookmarksModal: BDModalComponent;

    public folder: BDCPFolder;
    public pseudoProducts: any[];

    public newFolderName: string;

    private folderId: number;

    public constructor(
        private route: ActivatedRoute,
        private folderService: IBDCPFolderService,
        private location: Location
    ) { }

    public ngOnInit(): void {
        this.route.params.subscribe((params: Params) => {
            this.init(Number(params['folderId']));
        });
    }

    public async deleteProductFromFolder(sku: string): Promise<void> {
        await this.folderService.deleteProduct(this.folderId, sku);
        this.folder = await this.folderService.get(this.folderId, true);
    }

    public back(): void {
        this.location.back();
    }

    public requestProject(): void {
        // web
        window.open('https://secure.brother.de/portal/index.cfm?pos=prj3', 'blank');
        // iOS
        // window.location.href = 'https://secure.brother.de/portal/index.cfm?pos=prj3';
    }

    public async updateFolder(): Promise<void> {
        await this.folderService.update(this.folder.id, this.newFolderName);
        this.bookmarksModal.close();
        this.newFolderName = this.folder.name;
        this.folder = await this.folderService.get(this.folder.id, true);
    }

    private async init(folderId: number): Promise<void> {
        this.folderId = folderId;
        this.folder = await this.folderService.get(this.folderId, true);
        this.newFolderName = this.folder.name;
        this.calcPseudoProducts();
    }


    private calcPseudoProducts(): void {
        this.pseudoProducts = Array(!this.folder.favoriteProducts
            ? 0
            : 3 - (this.folder.favoriteProducts.length % 3)).fill(0);
    }
}
